import axiosInstance from "../axios/axiosInstance";

export const appealBan = async (appealReason: string) => {
  const response = await axiosInstance.post(`/user/ban/appeal`, { appealReason });
  return response;
};

export const getUserBan = async () => {
  const response = await axiosInstance.get(`/user/ban`);
  return response.data;
};
